import { useState } from "react";
import BWStatusFilter from "./BWStatusFilter";
import LateTasksFilter from "./LateTasksFilter";
import CommonGrid from "../CommonGrid/CommonGrid";
import CPPFA from "../../AWMJobs/CPPFA";
import { useDispatch, useSelector } from "react-redux";
import { getTaskGridColumns, taskGridFilters, taskGridGlobalFilterFields } from "./gridConfig";
import { getTaskDetails } from "../../../store/actions/taskDetailAction";
import "./ModuleGrids.scss";
import ExportSelectedRows from "../../ExportCSV";

const TaskGrid = ({
  data = [],
  mode = "min",
  dataKey = "TaskName",
  emptyMessage = "No tasks found.",
  tableProps = {},
  rows = 20,
  paginator,
  title = ""
}) => {
  const bwOptions = [
    { label: "On Track", value: "onTrack" },
    { label: "At Risk", value: "atRisk" },
    { label: "Off Track", value: "offTrack" },
  ];
  const [bwValue, setBwValue] = useState([]);
  const [showLateTasksOnly, setShowLateTasksOnly] = useState(dataKey.includes("FL"));
  const [showApproveDialogCPPFA, setShowApproveDialogCPPFA] = useState(false);
  const [selectedTaskApproveDialogCPPFA, setSelectedTaskApproveDialogCPPFA] = useState([]);
  const [fullData, setFullData] = useState({});
  const baseUrl = window.location.origin + "/allTasks";
  const dispatch = useDispatch();

  const User = useSelector((state) => state.UserReducer);
  const {
      userDetails: { UserGroup },
    } = useSelector((state) => state.UserDetailsReducer);
    const { TaskDetailsData } = useSelector((state) => state.TaskDetailsReducer);

  const userInformation = User?.userInformation;

  const handleApproveDialogCPPFA = async (e, options) => {
    e.preventDefault();

    const userAccessPayLoad = {
      ArtworkAgilityPage: {
        UserId: userInformation?.userid,
        ProjectID: options.AWMProjectID,
        UserGroup: UserGroup,
      },
    };

    setShowApproveDialogCPPFA(true);

    let task = {
      TaskID: options.AWMTaskID,
      ProjectID: options.AWMProjectID,
    };

    // Dispatch the async action and wait for it to finish
    try {
      const fullResponse = await dispatch(
        getTaskDetails(options.AWMTaskID, options.AWMProjectID, userAccessPayLoad)
      );

      // After the request is completed, pass the response to getFullData
      setFullData(fullResponse);
      setSelectedTaskApproveDialogCPPFA(task);
    } catch (error) {
      console.error("Error fetching task details:", error);
    }
  };

  // Use shared columns definition
  const columns = getTaskGridColumns(mode, dispatch, handleApproveDialogCPPFA);

  // Use shared filters/globalFilterFields
  const maximizedFilters = taskGridFilters;
  const maximizedGlobalFilterFields = taskGridGlobalFilterFields;

  // Helper to get B:W status from value
  const getBWStatus = (value) => {
    // Convert to number if it's a string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // Handle null, undefined, NaN, or N/A values (9999)
    if (numValue == null || isNaN(numValue) || numValue === 9999 || numValue === 9999.00) {
      return null;
    }
    
    if (numValue <= 0) return "offTrack";
    if (numValue > 0 && numValue <= 0.3) return "atRisk";
    if (numValue > 0.3) return "onTrack";
    return null;
  };

  // Filter data based on selected B:W values
  const filteredData =
    mode === "max" && (bwValue.length > 0 || showLateTasksOnly)
      ? data.filter((row) => {
          const bwMatch = bwValue.length === 0 || bwValue.includes(getBWStatus(row.BufferToWork));
          const lateTaskMatch = !showLateTasksOnly || row.LateTask === "1";
          return bwMatch && lateTaskMatch;
        })
      : data;

  return (
    <>
      {mode === "max" && (
        <div className="task-grid-filters">
          <ExportSelectedRows
            allData={filteredData}
            selectedRows={[]}
            headers={columns?.map(col => col?.field)?.filter(colNames => colNames !== "LateTask")}
            filename={`${title}_Records`}
          />
          <BWStatusFilter bwOptions={bwOptions} value={bwValue} setValue={setBwValue} />
          <LateTasksFilter value={showLateTasksOnly} setValue={setShowLateTasksOnly} />
        </div>
      )}
      <CommonGrid
        data={filteredData}
        columns={columns}
        mode={mode}
        filters={mode === "max" ? maximizedFilters : undefined}
        globalFilterFields={mode === "max" ? maximizedGlobalFilterFields : undefined}
        dataKey={dataKey}
        emptyMessage={emptyMessage}
        rows={rows}
        paginator={mode === "max" ? paginator : undefined}
        tableProps={tableProps}
        showACPFilter={true}
      />
      {showApproveDialogCPPFA && (
        <CPPFA
          onClose={() => setShowApproveDialogCPPFA(!showApproveDialogCPPFA)}
          showTaskDialog={showApproveDialogCPPFA}
          selectedTaskData={selectedTaskApproveDialogCPPFA}
          pegadata={filteredData}
          TaskDetailsData={TaskDetailsData}
          userInformation={userInformation}
          fullResponse={fullData}
        />
      )}
    </>
  );
};
export default TaskGrid;
